var map = {
	"./coil-large.svg": 35,
	"./coil-medium.svg": 36,
	"./coil-small.svg": 37,
	"./none.svg": 38,
	"./usb-a-gold.svg": 39,
	"./usb-a-silver.svg": 40,
	"./usb-c-gold.svg": 41,
	"./usb-c-silver.svg": 42,
	"./usb-mini-gold.svg": 43,
	"./usb-mini-silver.svg": 44
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4;